import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import {t} from 'i18next';
import './FieldTypeDrawer.scss';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {ArrDrawer} from '../../../../common/arr-drawer/ArrDrawer';

export interface FieldTypeDrawerProps {
  title: string;
  isOpen: boolean;
  onClose?: () => void;
  onSave?: () => void;
  canSave?: boolean;
  children?: React.ReactNode;
  disableRestoreFocus?: boolean;
}

const FieldTypeDrawer: React.FC<FieldTypeDrawerProps> = ({
  title,
  isOpen,
  onClose,
  onSave,
  canSave,
  children,
  disableRestoreFocus,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleCloseClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClose && onClose();
  };

  const handleCloseKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.code === 'Enter') {
      e.stopPropagation();
      onClose && onClose();
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSaveClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onSave && onSave();
  };

  const handleSaveKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.code === 'Enter') {
      e.stopPropagation();
      onSave && onSave();
    }
  };

  return (
    <>
      <ArrDrawer
        size="large"
        side="right"
        showButton={false}
        showHeader={false}
        isOpen={isOpen}
        onClose={() => {
          onClose && onClose();
        }}
        disableRestoreFocus={disableRestoreFocus}
      >
        <Stack className="field-type-drawer">
          {/* Header */}
          <Stack direction={'row'} spacing={1} className="drawer-header">
            {/* Header - Title */}
            <Stack spacing={1} className="drawer-title" tabIndex={0}>
              <Typography
                className="typo-text subhead5_size"
                data-testid={`field-type-drawer-insert`}
              >
                {t('sessionSearch.fieldDrawer.insert')}
              </Typography>
              <Typography
                className="typo-text headline3_size"
                data-testid={`field-type-drawer-title`}
              >
                {title}
              </Typography>
            </Stack>

            {/* Header - Actions */}
            <Stack direction={'row'} spacing={1} className="drawer-actions">
              <ArrButton
                size="medium"
                variant="secondary"
                onClick={handleCloseClick}
                onKeyDown={handleCloseKeyDown}
                className="button-cancel"
                dataTestId="button-cancel"
              >
                {t('sessionSearch.fieldDrawer.cancelButton')}
              </ArrButton>
              <ArrButton
                size="medium"
                variant="primary"
                onClick={handleSaveClick}
                onKeyDown={handleSaveKeyDown}
                isAriaDisabled={!canSave}
                className={`button-insert ${canSave ? '' : 'btn-disabled'}`}
                dataTestId="button-insert"
              >
                {t('sessionSearch.fieldDrawer.saveButton')}
              </ArrButton>
            </Stack>
          </Stack>

          {/* Contents */}
          <Box className="drawer-content">{children}</Box>
        </Stack>
      </ArrDrawer>
    </>
  );
};

export default FieldTypeDrawer;
